
import { Component, Emit, Prop, Provide, ProvideReactive, Vue, Watch } from 'vue-property-decorator';
import ToolBarItem from './ToolBarItem.vue';
@Component({})
export default class ToolBar extends Vue {
  @Prop({ default: '' })
  @ProvideReactive('selectedValue')
  value!: string;
  @Prop({ default: false })
  isOpenPopup!: boolean;
  @Prop({ default: () => ({ x: 0, y: 0 }) })
  popupPosition!: { x: number; y: number };

  @Provide()
  selectItem = (value: string, title: string) => {
    this.onSelect(value);
    this.popupTitle = title;
  };

  popupTitle = '';
  popupWidth = 800;
  popupHeight = 500;

  onClose() {
    //自身を選択させることでトグルする。
    this.onSelect(this.value);
  }
  get popupStyle() {
    return {
      top: `${this.popupPosition.y}px`,
      left: `${this.popupPosition.x}px`,
      width: `${this.popupWidth}px`,
      height: `${this.popupHeight}px`,
    };
  }

  mounted() {
    window.addEventListener('keydown', this.onPopupKeyDown);
  }
  unmounted() {
    window.removeEventListener('keydown', this.onPopupKeyDown);
  }

  @Emit('onSelect')
  onSelect(value: string) {}

  @Emit('onScroll')
  onScroll(event: WheelEvent) {}

  calculatePopupPositoin(item: ToolBarItem) {
    const rect = item.getToolBarItemRect();
    const updatedPosition = { x: rect.x, y: rect.y };
    const popupWidth = this.popupWidth;
    const popupHeight = this.popupHeight;
    if (rect.x < 0) {
      updatedPosition.x = rect.x < 0 ? 0 : rect.x;
    } else if (rect.x + popupWidth > window.innerWidth) {
      updatedPosition.x = rect.x + popupWidth > window.innerWidth ? window.innerWidth - popupWidth : rect.x;
    }
    if (rect.y < 0) {
      updatedPosition.y = rect.y < 0 ? 0 : rect.y;
    } else if (rect.y + popupHeight > window.innerHeight) {
      updatedPosition.y = rect.y + popupHeight > window.innerHeight ? rect.y - popupHeight : rect.y;
    }
    return updatedPosition;
  }

  onPopupKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.onClose();
    }
  };
}
